







































import {
  Component, Model, Prop, Vue,
} from 'vue-property-decorator';
import AppInputElement from './AppInputElement';
import { DropDownItem, DropdownGroup } from '../../select/types/dropdownItem';
import AppDropdown from '../../select/AppDropdown.vue';

@Component({
  components: { AppDropdown },
})
export default class DropdownInputElement<T> extends Vue
  implements AppInputElement<DropDownItem<T>> {
  name = 'DropdownInputElement';

  @Model('change', { type: Object, required: false, default: false }) model!: DropDownItem<T>;

  @Prop({ type: Array, required: true }) readonly items!: Array<DropdownGroup<T>>;

  @Prop({ type: Boolean, required: false, default: false }) readonly disabled!: boolean;

  @Prop({
    type: Function,
    required: false,
    default: (value: DropDownItem<T>) => true,
  }) readonly validator!: (value: DropDownItem<T>) => boolean;

  @Prop({ type: String, required: false, default: undefined }) readonly errorMessage!: string;

  @Prop({ type: String, required: false, default: undefined }) readonly title!: string;

  @Prop({ type: String, required: false, default: undefined }) readonly description!: string;

  @Prop({ type: Object, required: false, default: undefined }) readonly default!: DropDownItem<T>;

  id: string = null;

  get value(): DropDownItem<T> {
    return this.model;
  }

  set value(dropDownItem: DropDownItem<T>) {
    this.$emit('change', dropDownItem);
  }

  get defaultItem(): DropDownItem<T> {
    return this.model
      ?? this.items
        .find((group) => group.items.length)
        .items
        .find((item) => !item.disabled);
  }

  created() {
    this.id = Math.random().toString(36).substring(7);
  }
}
